const HHMM_TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;
const MERIDIEM_TIME_PATTERN = /^(\d{1,2})(?::(\d{2}))?\s*([ap]m)$/i;

function buildInvalidTimeSpecificationResult(input) {
    return {
        ok: false,
        input,
        error: 'Invalid time specification',
    };
}

export function parseTimeSpecification(input) {
    if (typeof input !== 'string') {
        return buildInvalidTimeSpecificationResult(input);
    }

    const trimmedInput = input.trim();
    if (trimmedInput === '') {
        return buildInvalidTimeSpecificationResult(input);
    }

    if (HHMM_TIME_PATTERN.test(trimmedInput)) {
        return {
            ok: true,
            input,
            value: trimmedInput,
        };
    }

    const meridiemMatch = MERIDIEM_TIME_PATTERN.exec(trimmedInput);
    if (!meridiemMatch) {
        return buildInvalidTimeSpecificationResult(input);
    }

    const hours = Number(meridiemMatch[1]);
    const minutes = meridiemMatch[2] ? Number(meridiemMatch[2]) : 0;
    const meridiem = meridiemMatch[3].toLowerCase();

    if (hours < 1 || hours > 12 || minutes < 0 || minutes > 59) {
        return buildInvalidTimeSpecificationResult(input);
    }

    let normalizedHours = hours % 12;
    if (meridiem === 'pm') {
        normalizedHours += 12;
    }

    return {
        ok: true,
        input,
        value: `${String(normalizedHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
    };
}

export function validateTimeValue(input, label = 'Time') {
    if (typeof input !== 'string' || input.trim() === '') {
        return `${label} is required.`;
    }

    if (!HHMM_TIME_PATTERN.test(input)) {
        return `${label} must be in HH:MM 24-hour format.`;
    }

    return true;
}

export function validateTimePeriod(timePeriod) {
    if (!timePeriod || typeof timePeriod !== 'object') {
        return 'TimePeriod is required.';
    }

    const timeFromValidation = validateTimeValue(timePeriod.time_from, 'Time From');
    if (timeFromValidation !== true) {
        return timeFromValidation;
    }

    const timeToValidation = validateTimeValue(timePeriod.time_to, 'Time To');
    if (timeToValidation !== true) {
        return timeToValidation;
    }

    return true;
}
